// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_eNT","cls2":"common-cls2_hxI common-cls1_eNT"};